import React from 'react';

import { Buttons } from '../../components/buttons';

import Tape from '../../img/steps-tape.webp';
import Device from '../../img/device-1.webp';
import Paper from '../../img/paper.webp';
import Number1 from '../../img/number-1.webp';
import Number2 from '../../img/number-2.webp';
import Number3 from '../../img/number-3.webp';

import * as styles from './index.module.scss';

export const Steps = () => (
  <section className={styles.main}>
    <div className="container">
      <div className={styles.wrap}>
        <div className={styles.title}>
          <h1 className={styles.titleText}>
            Скачай приложение <span className="nowrap">и забирай</span> фрибет
          </h1>
          <img className={styles.tape} src={Tape} alt="Tape" />
        </div>
        <div className={styles.columns}>
          <div className={styles.column}>
            <div className={styles.columnBg}>
              <img className={styles.paper} src={Paper} alt="Paper" />
            </div>
            <img className={styles.device} src={Device} alt="Device" />
          </div>
          <div className={styles.column}>
            <ul className={styles.list}>
              <li className={styles.item}>
                <img className={styles.number} src={Number1} alt="1" />
                <p className={styles.text}>Скачай приложение</p>
              </li>
              <li className={styles.item}>
                <img className={styles.number} src={Number2} alt="2" />
                <p className={styles.text}>Зарегистрируйся и&nbsp;пройди идентификацию</p>
              </li>
              <li className={styles.item}>
                <img className={styles.number} src={Number3} alt="3" />
                <p className={styles.text}>Пополни счёт и&nbsp;получи фрибет</p>
              </li>
            </ul>
            <Buttons isMobileMinified className={styles.buttons} buttonClassName={styles.button} />
          </div>
        </div>
      </div>
    </div>
  </section>
);
